import React from 'react';
import PropTypes from 'prop-types';
import { ReactPageClick } from 'react-page-click';

const GridContextMenu = (props) => {
  const style = {
    position: 'fixed',
    top: `${props.y}px`,
    left: `${props.x}px`,
  };

  const handleClick = (e, action) => {
    action(e);
    props.onClose();
  };

  return (
    <ReactPageClick notify={props.onClose}>
      <div style={style} className="grid-context-menu">
        <div
          className="grid-context-menu-action"
          onClick={e => handleClick(e, props.onClearFilters)}
        >
          Limpar Filtros
        </div>
        <div
          className="grid-context-menu-action"
          onClick={e => handleClick(e, props.openConfig)}
        >
          Configurações
        </div>
        {/* <div
          className="grid-context-menu-action"
          onClick={props.hintsPermission ?
            e => handleClick(e, props.openHint) : () => {}}
        >
          Gerenciar hints
        </div> */}
      </div>
    </ReactPageClick>
  );
};

GridContextMenu.propTypes = {
  onClearFilters: PropTypes.func.isRequired,
  openConfig: PropTypes.func.isRequired,
  openHint: PropTypes.func.isRequired,
  hintsPermission: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  y: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired
};

export default GridContextMenu;
